module.exports = (__webpack_require__(24))(135);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/process/browser.js from dll-reference lib_core
// module id = 921
// module chunks = 103